import user from './user'
export default {
  data() {
    return {
      user
    };
  },
  computed: {
    locationQuery() {
      return this.$root.urlQueries();
    },
    pageLabel() {
      return this.locationQuery && (this.locationQuery.pageLable || this.locationQuery.pageLabel || this.locationQuery.pagelabel || this.locationQuery.pagelable);
    }
  }
}